module.exports = __webpack_public_path__ + "static/media/a5_parking.fc02f1a8.png";